<template>
  <InsightsChartsTab :charts="chartConfigurations" :filters="filters" :dateRange="dateRange" :pdfMode="pdfMode" />
</template>

<script>
import { CHART_NAMES, INSIGHTS_CHARTS } from '@/helpers/insightsCharts'

export default {
  name: 'InsightsClaimsTab',
  props: {
    filters: {
      type: Array,
      required: true,
      default: () => []
    },
    dateRange: {
      type: Array,
      required: true,
      default: () => []
    },
    pdfMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartConfigurations () {
      const chartTypes = [
        CHART_NAMES.CLAIMS_REPORTED_BY,
        CHART_NAMES.CLAIMS_PER_STATUS,
        CHART_NAMES.CLAIMS_VALUE_CONTRACTOR,
        CHART_NAMES.CLAIMS_VALUE_EMPLOYER,
        CHART_NAMES.CLAIMS_VALUE_AND_COUNT,
        CHART_NAMES.EOT_PER_FINALIZED_CLAIMS,
        CHART_NAMES.CLAIMS_TREND
      ]

      return chartTypes.map(chartName => ({
        name: chartName,
        componentName: INSIGHTS_CHARTS[chartName].component,
        defaultQuery: INSIGHTS_CHARTS[chartName].defaultQuery,
        defaultTimeDimension: INSIGHTS_CHARTS[chartName].defaultTimeDimension,
        chartWidth: INSIGHTS_CHARTS[chartName].chartWidth
      }))
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.dispatchEvent(new Event('resize'))
    })
  }
}
</script>
